interface AISubjectLineListProps {
  subjects: string[];
  onSelect: (subject: string) => void;
}

export default function AISubjectLineList({ subjects, onSelect }: AISubjectLineListProps) {
  return (
    <div className="my-4 bg-white border border-gray-200 rounded-xl overflow-hidden">
      <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
        <span className="text-xs font-medium text-gray-500 uppercase">AI Generated Subject Lines</span>
      </div>
      <div className="divide-y divide-gray-100">
        {subjects.map((subject, i) => (
          <button
            key={i}
            onClick={() => onSelect(subject)}
            className="w-full px-4 py-3 text-left hover:bg-blue-50 transition-colors flex items-center justify-between group"
          >
            <span className="text-sm text-gray-900">{subject}</span>
            <span className="text-xs text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity font-medium">
              Use this
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
